import React from 'react';

export default function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-util/es/Children/toArray.js
// module id = 43
// module chunks = 14